<template>
    <!-- 新手指导 -->
    <div class="container">
        <!-- <p>新</p> -->
        <Title-b :title="$t('Side.Noviceguidance')" />
        <div class="hr"></div>
        <div class="one">
            <h1>一、注册会员账号</h1>
            <p @click="dj()">首先：点击链接进入集运VIP会员中心：<span style="display:inline-block;color:red">http://member.best-muster.com</span></p>
            <br>
            <Title-b title="步骤1：点击【立即注册】：" />
            <br>
            <img src="@/assets/images/sjOne.jpg" alt="" style="width:100%">
            <br>
            <Title-b title="步驟2：填写会员信息" />
            <br>
            <img src="@/assets/images/sjTwo.jpg" alt="" style="width:100%">
            <br>
            <p><span class="p">会员用戶名(必填)：</span>用戶名建请输入便于您牢记的任何数字或者手机号码作为登录用戶名；</p>
            <p><span class="p">密码设定 (必填)：</span>设置您的登录密码（至少6位数 要牢记），再次输入确定密码；</p>
            <p><span class="p">电子邮箱 (必填)：</span>填写有效的电子邮箱，便于接受快递入库、包裹物流轨迹、优惠券活动等信息</p>
            <p><span class="p">手机号码 (选填)：</span>选填项，可不写</p>
            <p><span class="p">推荐人编码 (选填)：</span>選填項，如有推薦人時填寫推薦人的ID編碼，如沒有推薦人則不用填寫；</p>
            <br>
            <Title-b title="步驟3：" />
            <p>认真阅读《承运条款》条款后，勾选我已同意集运《承运条款》；最后，点击【立即注册】按钮即可注册成功</p>
            <br>
            
            <h1>二、登录会员中心</h1>
            <img src="@/assets/images/sjThree.jpg" alt="" style="width:100%">
            <br>
            <Title-b title="步驟1：" style="display: inline-block;" /><span>输入您注册时填写的会员用户名或者ID编码（ID编码首次注册要进入会员中心后才可以看到）；</span><br>
            <Title-b title="步驟2：" style="display: inline-block;" /><span>输入您注册时填写的会员登录密码；</span><br>
            <Title-b title="步驟3："  style="display: inline-block;" /><span>根据右边框中出现的数字按顺序输入验证码；</span><br>
            <Title-b title="步驟4：" style="display: inline-block;" /><span>最后点击【登录】即可进入到会员中心；</span><br>
            <br>
            <h1>三、获取集运仓库地址</h1>
            <Title-b title="步驟1：登录会员中心---在会员中心页面最下方找到【仓库地址广州仓】点“复制”获取您的专属集运仓库地址；" />
            <img src="@/assets/imgs/si.jpg" alt="">
            <Title-b title="步驟2：将您复制的“仓库地址”在您购物的电商平台上添加为收货地址，或直接提供给发货方将货物发往集运仓库。" />
            <!-- <p>如下圖，以淘寶平臺購物為例：</p>
            <img src="@/assets/imgs/wu.png" alt=""> -->
            <br>

            <h1>四、预报包裹</h1>
            <Title-b title="步骤1：会员中心在快速通道找到“预报包裹”；" />
            <img src="@/assets/imgs/liu.jpg" alt="">
            <br>
            <Title-b title="步骤2：在您购物的电商平台上，将卖家发货后的物流快递单号进行复制" />
            <p>如下图，以淘宝平台购物为例：</p>
            <img src="@/assets/imgs/qi.png" alt="">
            <br>
            <Title-b title="步骤3：将您复制的快递单号、集运的货物品名、类型以及数量，在预报包裹界面正确填写。" />
            <p>如下图1，单个包里预报示例：</p>
            <img src="@/assets/imgs/ba.png" alt="">
            <p>如下图2，包裹批量预报示例：</p>
            <img src="@/assets/imgs/jiu.png" alt="">
            <p><span class="p">快递单号：</span>指您在电商平台购物，卖家发货后显示的快递物流但还；</p>
            <p><span class="p">货物品名：</span>指您所要集运的货物名称（必须要實填写、预报），虚报填写后果自负，入不确定是否可集运的货物可咨询客服哦；</p>
            <p><span class="p">货物类型：</span>普货、敏感货、防疫物品</p>
            <p><span class="p">物品数量：</span>指快递包裹物品數量；</p>
            <p><span class="p">备注说明（选填）：</span>特殊物品需备注说明，并告知客服；</p>
            <p>最后，确认预报包裹信息点<span class="p">【提交】</span>即可预报成功。</p>
            <br>


            <h1>五、添加收貨地址</h1>
            <Title-b title="步骤1：会员中心点击“地址管理” " />
            <img src="@/assets/imgs/shi.jpg" alt="">
            <br>
            <Title-b title="步骤2：点击“ 添加收货地址”， 根据提示正确填写收货地址信息并保存。 " />
            <img src="@/assets/imgs/shiyi.png" alt="" style="width:90%">
            <br>
            <p>提示：新添加的收货地址需集运审核后方能使用，建议您提前添加。</p>
            <img src="@/assets/imgs/shier.png" alt="">
            <br>


            <h1>六、申請集運</h1>
            <p>申请集运需显示在“已入库”状态后方可操作，如显示“待入库”状态暂时不可以申请集运</p>
            <Title-b title="步骤1.：会员中心，点击“申请集运”" />
            <img src="@/assets/imgs/shisan.jpg" alt="">
            <br>
            <Title-b title="步骤2：进入“已入库”界面后,根据您的实际需求可一次性申请全部货物集运或者选择单件货物集运，选择完成后点击“申请集运。”" />
            <img src="@/assets/imgs/shisi.png" alt="" style="width:90%">
            <br>
            <Title-b title="步骤3：确认集运包裹信息，根据您的需求正确选择收货地址。 " />
            <img src="@/assets/imgs/shiwu.png" alt="" style="width:90%">
            <br>
            <Title-b title="步驟4：付款方式選擇" />
            <p>集运付款方式支持余额支付、微信支付、支付宝支付、中国银行支付、微信支付仅限大陆版确认集运货物信息，根据您的<br>实际情况选择适合您的支付方式，最后点“申请集运”</p>
            <!-- <img src="@/assets/imgs/shiliu.png" alt=""> -->
            <br>
            <!-- <p class="p">關於淘寶店支付：</p>
            <p>淘寶店支付需要到集運的專屬店鋪去支付運費，選擇對應的運費鏈接支付（運費總金額=數量，根據實際運費總金額<br>輸入相等的數量），在提交訂單頁必須在賣家留言處備註ID編碼或者支付碼。</p>
            <p><span>1：</span>點擊<span class="p">“複製”</span>支付碼；</p>
            <img src="@/assets/imgs/shiqi.png" alt="">
            
            <p><span>2：</span>點擊鏈接進入到的專屬淘寶店後，選擇對應的鏈接（比如總運費金額為45.1元：那麼先找到1.1的鏈接，在1元的選<br>項輸入<span style="color:red">44</span>，在1.1元的選項輸入<span style="color:red;">1 </span> ；
如下圖：</p>
            <img src="@/assets/imgs/ershi.png" alt="">
            <p><span>3：</span>點擊結算後，在賣家留言處粘貼您剛複製的支付碼或者ID編碼；</p>
            <img src="@/assets/imgs/shiba.png" alt="">
            <p>最後點擊<span>“提交訂單”</span>，付款成功。</p>
            <br>


            <h1>七、等待收貨</h1>
            <p>申請集運付款成功後，可在我的訂單界面實時查看訂單狀態。</p>
            <img src="@/assets/imgs/shijiu.png" alt="">
            <p>集運：香港：時效2-3個工作日，泰国：时效5-7个工作日，台湾空运：3-4个工作日，海运：5-7个工作日，越南陆运：4-6个工作日特殊情況：
當遇上天氣惡劣/海關查處/雨天/公眾假期/偏遠地區/6.18/雙11/雙12等情況，為了保證貨物安全，貨物可能會延遲派送，
特殊情況請留意集運官網公告。</p> -->
        </div>
    </div>
</template>
<script>
export default {
    methods:{
        dj(){
            this.$router.push('./register');
        }
    }
}
</script>
<style lang="scss" scoped>
    .container{
        width: 1069px;
        border-radius: 5px;
        background: #fff;
        padding: 19px 17px;
        /deep/ .unify-title{
            font-weight: bold;
            font-size: 18px;
            height: 18px;
            margin: 10px 0;
        }
        .hr{
            margin: 15px 0 0 0;
            width: 1000px;
            height: 1px;
            border-bottom: 1px solid #cccccc;
        }
        .one{
            margin: 10px 0 0 0;
            h1{
                font-weight: bold;
                color: #000;
            }
            .p{
                font-weight: bold;
            }
            p{
                margin: 5px 0;
                font-size: 18px;
                cursor: pointer;
                color: #000;
            }
            img{
                margin: 10px 0px;
            }
            span{
                // display: inherit;
                font-size: 16px;
                color: #000;
                cursor: pointer;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/view/memberservices/Noviceguidance.vue